import { React } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../../../Context/LanguageContext';
import { useTheme } from '../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../Styles/theme';

const MemberShipColumn = () => {
  const { t } = useLanguage();

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  return (
    <TopLevelWrapper>
      <Column width={280} style={{marginLeft: '15px'}}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.colMembership')}</Text>
      </Column>
      <Column width={145}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.colPeriod')}</Text>
      </Column>
      <Column width={190}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.colPayment')}</Text>
      </Column>
      <Column width={80}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.colUnpaid')}</Text>
      </Column>
      <Column width={4} />
      <Column width={55}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.colRemaining')}</Text>
      </Column>
      <Column width={90}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.colSessions')}</Text>
      </Column>
    </TopLevelWrapper>
  )
}

export default MemberShipColumn;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  
  justify-content: flex-start;
  align-items: flex-start;

  margin: 34px 0px 20px 0px;

  width: 970px;

  gap: 15px;

  transition: all 0.3s ease-in-out;
`;

const Column = styled.div`
  display: flex;
  flex-direction: row;
  
  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.width}px;
  height: 20px;

  overflow: hidden;
`;

const Text = styled.p`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;